// One capital-city time zone per national brief.
// IANA zones derive from local moment-timezone 0.6.3 metadata, with capital overrides.
export const COUNTRY_REPORT_TIME_ZONES: Record<string, string> = {
    AFG: 'Asia/Kabul',
    ALB: 'Europe/Tirane',
    DZA: 'Africa/Algiers',
    AND: 'Europe/Andorra',
    AGO: 'Africa/Luanda',
    ATG: 'America/Antigua',
    ARG: 'America/Argentina/Buenos_Aires',
    ARM: 'Asia/Yerevan',
    AUS: 'Australia/Sydney',
    AUT: 'Europe/Vienna',
    AZE: 'Asia/Baku',
    BHS: 'America/Nassau',
    BHR: 'Asia/Bahrain',
    BGD: 'Asia/Dhaka',
    BRB: 'America/Barbados',
    BLR: 'Europe/Minsk',
    BEL: 'Europe/Brussels',
    BLZ: 'America/Belize',
    BEN: 'Africa/Porto-Novo',
    BTN: 'Asia/Thimphu',
    BOL: 'America/La_Paz',
    BIH: 'Europe/Sarajevo',
    BWA: 'Africa/Gaborone',
    BRA: 'America/Sao_Paulo',
    BRN: 'Asia/Brunei',
    BGR: 'Europe/Sofia',
    BFA: 'Africa/Ouagadougou',
    BDI: 'Africa/Bujumbura',
    CPV: 'Atlantic/Cape_Verde',
    KHM: 'Asia/Phnom_Penh',
    CMR: 'Africa/Douala',
    CAN: 'America/Toronto',
    CAF: 'Africa/Bangui',
    TCD: 'Africa/Ndjamena',
    CHL: 'America/Santiago',
    CHN: 'Asia/Shanghai',
    COL: 'America/Bogota',
    COM: 'Indian/Comoro',
    COD: 'Africa/Kinshasa',
    COG: 'Africa/Brazzaville',
    CRI: 'America/Costa_Rica',
    CIV: 'Africa/Abidjan',
    HRV: 'Europe/Zagreb',
    CUB: 'America/Havana',
    CYP: 'Asia/Nicosia',
    CZE: 'Europe/Prague',
    DNK: 'Europe/Copenhagen',
    DJI: 'Africa/Djibouti',
    DMA: 'America/Dominica',
    DOM: 'America/Santo_Domingo',
    ECU: 'America/Guayaquil',
    EGY: 'Africa/Cairo',
    SLV: 'America/El_Salvador',
    GNQ: 'Africa/Malabo',
    ERI: 'Africa/Asmara',
    EST: 'Europe/Tallinn',
    SWZ: 'Africa/Mbabane',
    ETH: 'Africa/Addis_Ababa',
    FJI: 'Pacific/Fiji',
    FIN: 'Europe/Helsinki',
    FRA: 'Europe/Paris',
    GAB: 'Africa/Libreville',
    GMB: 'Africa/Banjul',
    GEO: 'Asia/Tbilisi',
    DEU: 'Europe/Berlin',
    GHA: 'Africa/Accra',
    GRC: 'Europe/Athens',
    GRL: 'America/Nuuk',
    GRD: 'America/Grenada',
    GTM: 'America/Guatemala',
    GIN: 'Africa/Conakry',
    GNB: 'Africa/Bissau',
    GUY: 'America/Guyana',
    HTI: 'America/Port-au-Prince',
    HND: 'America/Tegucigalpa',
    HUN: 'Europe/Budapest',
    ISL: 'Atlantic/Reykjavik',
    IND: 'Asia/Kolkata',
    IDN: 'Asia/Jakarta',
    IRN: 'Asia/Tehran',
    IRQ: 'Asia/Baghdad',
    IRL: 'Europe/Dublin',
    ISR: 'Asia/Jerusalem',
    ITA: 'Europe/Rome',
    JAM: 'America/Jamaica',
    JPN: 'Asia/Tokyo',
    JOR: 'Asia/Amman',
    KAZ: 'Asia/Almaty',
    KEN: 'Africa/Nairobi',
    KIR: 'Pacific/Tarawa',
    XKX: 'Europe/Belgrade',
    KWT: 'Asia/Kuwait',
    KGZ: 'Asia/Bishkek',
    LAO: 'Asia/Vientiane',
    LVA: 'Europe/Riga',
    LBN: 'Asia/Beirut',
    LSO: 'Africa/Maseru',
    LBR: 'Africa/Monrovia',
    LBY: 'Africa/Tripoli',
    LIE: 'Europe/Vaduz',
    LTU: 'Europe/Vilnius',
    LUX: 'Europe/Luxembourg',
    MDG: 'Indian/Antananarivo',
    MWI: 'Africa/Blantyre',
    MYS: 'Asia/Kuala_Lumpur',
    MDV: 'Indian/Maldives',
    MLI: 'Africa/Bamako',
    MLT: 'Europe/Malta',
    MHL: 'Pacific/Majuro',
    MRT: 'Africa/Nouakchott',
    MUS: 'Indian/Mauritius',
    MEX: 'America/Mexico_City',
    FSM: 'Pacific/Pohnpei',
    MDA: 'Europe/Chisinau',
    MCO: 'Europe/Monaco',
    MNG: 'Asia/Ulaanbaatar',
    MNE: 'Europe/Podgorica',
    MAR: 'Africa/Casablanca',
    MOZ: 'Africa/Maputo',
    MMR: 'Asia/Yangon',
    NAM: 'Africa/Windhoek',
    NRU: 'Pacific/Nauru',
    NPL: 'Asia/Kathmandu',
    NLD: 'Europe/Amsterdam',
    NZL: 'Pacific/Auckland',
    NIC: 'America/Managua',
    NER: 'Africa/Niamey',
    NGA: 'Africa/Lagos',
    PRK: 'Asia/Pyongyang',
    MKD: 'Europe/Skopje',
    NOR: 'Europe/Oslo',
    OMN: 'Asia/Muscat',
    PAK: 'Asia/Karachi',
    PLW: 'Pacific/Palau',
    PSE: 'Asia/Hebron',
    PAN: 'America/Panama',
    PNG: 'Pacific/Port_Moresby',
    PRY: 'America/Asuncion',
    PER: 'America/Lima',
    PHL: 'Asia/Manila',
    POL: 'Europe/Warsaw',
    PRT: 'Europe/Lisbon',
    QAT: 'Asia/Qatar',
    ROU: 'Europe/Bucharest',
    RUS: 'Europe/Moscow',
    RWA: 'Africa/Kigali',
    KNA: 'America/St_Kitts',
    LCA: 'America/St_Lucia',
    VCT: 'America/St_Vincent',
    WSM: 'Pacific/Apia',
    SMR: 'Europe/San_Marino',
    STP: 'Africa/Sao_Tome',
    SAU: 'Asia/Riyadh',
    SEN: 'Africa/Dakar',
    SRB: 'Europe/Belgrade',
    SYC: 'Indian/Mahe',
    SLE: 'Africa/Freetown',
    SGP: 'Asia/Singapore',
    SVK: 'Europe/Bratislava',
    SVN: 'Europe/Ljubljana',
    SLB: 'Pacific/Guadalcanal',
    SOM: 'Africa/Mogadishu',
    ZAF: 'Africa/Johannesburg',
    KOR: 'Asia/Seoul',
    SSD: 'Africa/Juba',
    ESP: 'Europe/Madrid',
    LKA: 'Asia/Colombo',
    SDN: 'Africa/Khartoum',
    SUR: 'America/Paramaribo',
    SWE: 'Europe/Stockholm',
    CHE: 'Europe/Zurich',
    SYR: 'Asia/Damascus',
    TWN: 'Asia/Taipei',
    TJK: 'Asia/Dushanbe',
    TZA: 'Africa/Dar_es_Salaam',
    THA: 'Asia/Bangkok',
    TLS: 'Asia/Dili',
    TGO: 'Africa/Lome',
    TON: 'Pacific/Tongatapu',
    TTO: 'America/Port_of_Spain',
    TUN: 'Africa/Tunis',
    TUR: 'Europe/Istanbul',
    TKM: 'Asia/Ashgabat',
    TUV: 'Pacific/Funafuti',
    UGA: 'Africa/Kampala',
    UKR: 'Europe/Kyiv',
    ARE: 'Asia/Dubai',
    GBR: 'Europe/London',
    USA: 'America/New_York',
    URY: 'America/Montevideo',
    UZB: 'Asia/Tashkent',
    VUT: 'Pacific/Efate',
    VAT: 'Europe/Vatican',
    VEN: 'America/Caracas',
    VNM: 'Asia/Ho_Chi_Minh',
    YEM: 'Asia/Aden',
    ZMB: 'Africa/Lusaka',
    ZWE: 'Africa/Harare',
};

const DAY_MS = 86_400_000;
const formatters = new Map<string, Intl.DateTimeFormat>();
const dayWindows = new Map<string, { start: number; end: number }>();

function formatter(timeZone: string): Intl.DateTimeFormat {
    let value = formatters.get(timeZone);
    if (!value) {
        value = new Intl.DateTimeFormat('en-US', {
            timeZone, year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
        });
        formatters.set(timeZone, value);
    }
    return value;
}

export function countryReportTimeZone(iso3: string): string {
    const timeZone = COUNTRY_REPORT_TIME_ZONES[iso3.toUpperCase()];
    if (!timeZone)
        throw new Error(`Missing report time zone for ${iso3}`);
    return timeZone;
}

export function zonedDateParts(instant: number, timeZone: string) {
    const values: Record<string, string> = {};
    for (const part of formatter(timeZone).formatToParts(instant))
        values[part.type] = part.value;
    return {
        date: `${values.year}-${values.month}-${values.day}`,
        hour: Number(values.hour),
        minute: Number(values.minute)
    };
}

export function countryReportDate(iso3: string, instant: number): string {
    return zonedDateParts(instant, countryReportTimeZone(iso3)).date;
}

function localMidnight(date: string, timeZone: string): number {
    const anchor = Date.parse(`${date}T00:00:00.000Z`);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !Number.isFinite(anchor))
        throw new Error(`Invalid report date: ${date}`);
    let low = anchor - 2 * DAY_MS;
    let high = anchor + 2 * DAY_MS;
    while (low < high) {
        const middle = Math.floor((low + high) / 2);
        if (zonedDateParts(middle, timeZone).date < date)
            low = middle + 1;
        else
            high = middle;
    }
    if (zonedDateParts(low, timeZone).date !== date)
        throw new Error(`Report date unavailable in ${timeZone}: ${date}`);
    return low;
}

export function countryReportDayWindow(date: string, timeZone: string) {
    const key = `${timeZone}|${date}`;
    const cached = dayWindows.get(key);
    if (cached)
        return cached;
    const anchor = Date.parse(`${date}T00:00:00.000Z`);
    const nextDate = new Date(anchor + DAY_MS).toISOString().slice(0, 10);
    const window = { start: localMidnight(date, timeZone), end: localMidnight(nextDate, timeZone) };
    if (dayWindows.size >= 512)
        dayWindows.delete(dayWindows.keys().next().value!);
    dayWindows.set(key, window);
    return window;
}

export function nextReportDate(date: string): string {
    return new Date(Date.parse(`${date}T00:00:00.000Z`) + DAY_MS).toISOString().slice(0, 10);
}

export function countryPreparationPlan(iso3: string, instant: number) {
    const timeZone = countryReportTimeZone(iso3);
    const clock = zonedDateParts(instant, timeZone);
    if (clock.hour !== 19 || clock.minute !== 0)
        return null;
    const reportDate = nextReportDate(clock.date);
    return { reportDate, timeZone,
        publishAt: countryReportDayWindow(reportDate, timeZone).start + 3_600_000 };
}
